import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, NgZone, PLATFORM_ID } from '@angular/core';
import { TRACKING_CONFIG } from './tracking.config';
import { TrackingConfig } from './tracking.interface';
import { CustomTrackingEvent, TrackingEventData } from './tracking.model';

@Injectable()
export class TaboolaPixelTracking {
  private isEnabled = false;

  constructor(
    private ngZone: NgZone,
    @Inject(TRACKING_CONFIG) private config: TrackingConfig,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    if (this.config.taboolaPixelId && isPlatformBrowser(this.platformId)) {
      this.isEnabled = true;
      window._tfa = window._tfa || [];
    }
  }

  trackPageView(): void {
    if (!this.isEnabled) {
      return;
    }
    this.ngZone.runOutsideAngular(() => {
      this.loadTrackingSnippet();
      this.trackEvent('page_view');
    });
  }

  trackCustomEvent(payload: CustomTrackingEvent & TrackingEventData): void {
    if (!this.isEnabled) {
      return;
    }

    if (payload.taboolaEventName) {
      this.ngZone.runOutsideAngular(() => {
        this.loadTrackingSnippet();
        this.trackEvent(payload.taboolaEventName);
      });
    }
  }

  private loadTrackingSnippet(): void {
    const taboolaScriptElementId = 'tb_tfa_script';
    if (!document.getElementById(taboolaScriptElementId)) {
      const t = document.createElement('script');
      t.async = true;
      t.src = `//cdn.taboola.com/libtrc/unip/${this.config.taboolaPixelId}/tfa.js`;
      t.id = taboolaScriptElementId;

      const firstScriptElement = document.getElementsByTagName('script')[0];
      firstScriptElement.parentNode?.insertBefore(t, firstScriptElement);
    }
  }

  private trackEvent(eventName: string) {
    window._tfa.push({
      notify: 'event',
      name: eventName,
      id: this.config.taboolaPixelId,
    });
  }
}
